import { render, staticRenderFns } from "./BrochureCard.vue?vue&type=template&id=0c6a63da"
import script from "./BrochureCard.vue?vue&type=script&lang=js"
export * from "./BrochureCard.vue?vue&type=script&lang=js"
import style0 from "./BrochureCard.vue?vue&type=style&index=0&id=0c6a63da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports